import "./Header.scss";
import Navigation from "../Navigation/Navigation";

const Header = () => {
  return (
    <header className="sniff-header">
      <Navigation />
    </header>
  );
};

export default Header;
